<template>
    <ion-refresher slot="fixed" pull-factor="0.5" pull-min="50" pull-max="100" @ionRefresh="refresh($event)">
        <ion-refresher-content />
    </ion-refresher>
</template>

<script>
import {IonRefresher, IonRefresherContent} from '@ionic/vue';
export default {
    props: {'callback': Function},
    name: "PullDownRefresh",
    components: {IonRefresher, IonRefresherContent},
    methods: {
        refresh(event) {
            this.callback(event);
        }
    }
}
</script>

<style scoped>

</style>
